import { Component } from 'react';
import { observer } from 'mobx-react';
import moment from 'moment-timezone';

@observer
class BaseSaleFormComponent extends Component {
  handleValidation = (value) => {
    const { t, isRoundStarted } = this.props;
    if (isRoundStarted && !value) {
      return t('Fill required fields');
    }
    return '';
  };

  getFieldName = (field) => `${this.fieldPrefix}${field}`;

  handleChanged = (field) => (value) => {
    var { offerData } = this.props;
    offerData[field] = value;
  };

  handleChange = (field) => (ev, value) => {
    var { offerData } = this.props;
    offerData[field] = value;
  };

  handleChangedPair = (field, value) => {
    var { offerData } = this.props;
    offerData[field] = value;
  };

  handleChangedOptionKey = (field) => (option, index, value) => {
    var { offerData } = this.props;
    if (option) offerData[field] = option.key;
    else offerData[field] = value;
  };

  handleChangeOptionKey = (field) => (ev, option, index, value) => {
    var { offerData } = this.props;
    if (option) offerData[field] = option.key;
    else offerData[field] = value;
  };

  handleChangeOptionKeyAndCleanWhenEmpty =
    (field, fieldsToClean) => (ev, option, index, value) => {
      var { offerData } = this.props;

      const v = !!option ? option.key : value;

      offerData[field] = v;

      if (!!fieldsToClean && (!v || v === 'none')) {
        fieldsToClean.forEach((f) => {
          offerData[f] = '';
        });
      }
    };

  handleToggleChanged = (field) => (_, value) => {
    var { offerData } = this.props;
    offerData[field] = value;
  };

  handleChangeMultiOptionKey = (field) => (ev, option) => {
    var { offerData } = this.props;
    var items = [...offerData[field]];
    if (option.selected) {
      items.push(option.key);
    } else {
      const currIndex = items.indexOf(option.key);
      if (currIndex > -1) {
        items.splice(currIndex, 1);
      }
    }
    offerData[field] = items;
  };

  handleChangedOptionText = (field) => (option, index, value) => {
    var { offerData } = this.props;
    if (option) {
      offerData[field] = option.text;
    } else if (value) {
      offerData[field] = value;
    }
  };

  handleChangedEnum = (field) => (item) => {
    var { offerData } = this.props;
    offerData[field] = item.key;
  };

  handleChangedBool = (field) => (ev, checked) => {
    var { offerData } = this.props;
    offerData[field] = checked;
  };

  handleArrayItemChanged = (array, index, field) => (value) => {
    var { offerData } = this.props;
    offerData[array][index][field] = value;
  };

  handleDateChanged = (field) => (value) => {
    var { offerData } = this.props;
    value = moment(value).hour(12).minute(0).toDate();
    offerData[field] = value;
  };

  handleTimeChange = (field) => (ev, option) => {
    var { offerData } = this.props;
    const duration = option.key;
    const h = moment.duration(duration, 'minutes').hours();
    const m = moment.duration(duration, 'minutes').minutes();
    offerData[field] = moment(offerData[field]).hour(h).minute(m).toDate();
  };

  handleChangedDate = (field) => (value) => {
    var { offerData } = this.props;
    if (value) value = value.toFormatedDateString('DD.MM.YYYY');
    offerData[field] = value;
  };

  handleCountryChange = (field) => (ev, option, index, value) => {
    var { offerData } = this.props;
    offerData[field] = option.text;
    offerData[`${field}_code`] = option.key;
  };

  renderFormatedDate = (date) => {
    return new Date(date).toFormatedDateString('L');
  };

  parseDateFromString = (value) => {
    return !!value ? moment(value, 'L').toDate() : value;
  };
}

export default BaseSaleFormComponent;



// WEBPACK FOOTER //
// ./src/app/components/SaleForm/BaseSaleFormComponent.jsx